import axios from 'axios';
import { baseUrl } from '@/config';

export default {

  /**
   * 미확인 패턴 수동 탐색
   * @author leesy918
   */
  SearchUncheckPattern(param) {
    return axios.post(`${baseUrl}/settings/lms-pattern-search/search-uncheck-pattern.do`, param);
  },
  /**
   * 탐색 시간 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getSearchTime() {
    return axios.get(`${baseUrl}/settings/lms-pattern-search/get-search-time.do`);
  },
  /**
   * 탐색 시간 설정
   * @author leesy918
   * @param  {[type]} param [description]
   * @return {[type]}       [description]
   */
  updateSearchTime(param) {
    return axios.post(`${baseUrl}/settings/lms-pattern-search/update-search-time.do`, param);
  },
  /**
   * 머신 러닝 패턴 추가 여부를 조회 한다.
   * @author leesy918
   * @param  {[type]} queryString [description]
   * @param  {[type]} param       [description]
   * @return {[type]}             [description]
   */
  checkInsertMlPattern() {
    return axios.get(`${baseUrl}/settings/lms-pattern-search/check-insert-ml-pattern.do`);
  },
  /**
   * 패턴 탐색 내역 조회
   * @author leesy918
   * @param  {[type]} param [description]
   * @return {[type]}       [description]
   */
  getMlPatternHist(param) {
    return axios.post(`${baseUrl}/settings/lms-pattern-search/get-ml-pattern-hist.do`, param);
  },

  /**
 * 패턴 탐색으로 생성된 패턴목록 조회
 * @author leesy918
 * @param  {[type]} param [description]
 * @return {[type]}       [description]
 */
  getHistPatternList(param) {
    return axios.post(`${baseUrl}/settings/lms-pattern-search/get-hist-pattern-list.do`, param);
  },

  /**
   * 패턴 히스트 팝업에서 패턴명 업데이트
   * @author leesy918
   * @param  {[type]} param [description]
   * @return {[type]}       [description]
   */
  updateHistPattern(param) {
    return axios.post(`${baseUrl}/settings/lms-pattern-search/update-hist-pattern.do`, param);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-pattern-search-setting.js